import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, selectAuthLoading, selectUser } from '../../store/slices/authSlice.js';

const PrivateRoute = ({ children, requiredRole, requiredRoles }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const user = useSelector(selectUser);
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-secondary-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role requirements
  const hasRequiredRole = () => {
    if (!requiredRole && !requiredRoles) return true;
    
    const userRole = user?.role?.role_name;
    
    if (requiredRole) {
      return userRole === requiredRole;
    }
    
    if (requiredRoles) {
      return requiredRoles.includes(userRole);
    }
    
    return true;
  };

  // If role requirements are not met, show access denied
  if (!hasRequiredRole()) {
    const roleRequirement = requiredRole || (requiredRoles ? requiredRoles.join(', ') : 'Sin especificar');
    
    return (
      <div className="flex items-center justify-center min-h-screen bg-secondary-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
              <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Acceso Denegado
            </h3>
            <p className="text-gray-600 mb-4">
              No tienes los permisos necesarios para acceder a esta página.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Rol(es) requerido(s): <span className="font-semibold">{roleRequirement}</span><br />
              Tu rol actual: <span className="font-semibold">{user?.role?.role_name || 'Sin rol'}</span>
            </p>
            <button
              onClick={() => window.history.back()}
              className="w-full bg-primary-600 text-white py-2 px-4 rounded-lg hover:bg-primary-700 transition-colors"
            >
              Volver
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;